import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScreensInterimState } from '../../reducers/generations/screen-interim.reducer';

export const screenInterimSelector = createFeatureSelector<ScreensInterimState>('screenInterim');

export const allInterimScreens = createSelector(screenInterimSelector, (state) => state.selectedScreens);

export const selectedScreenInterim = createSelector(screenInterimSelector, (state) => state.screenStructureInterim);

export const confAndFileCntSveSuccInterim = createSelector(screenInterimSelector, (state) => state.results);

export const confAndFileCntSveFailInterim = createSelector(screenInterimSelector, (state) => state.error);

export const deletedScreenInterimId = createSelector(screenInterimSelector, (state) => state.deletedScreenInterimId);

